function initDropdownToggle() {
  const dropdowns = document.querySelectorAll(".dropdown");

  dropdowns.forEach((dropdown) => {
    const dropdownBtn = dropdown.querySelector(".dropbtn");
    const dropdownContent = dropdown.querySelector(".dropdown-content");

    if (!dropdownBtn || !dropdownContent) return;

    // Toggle dropdown on button click
    dropdownBtn.addEventListener("click", function (event) {
      event.stopPropagation();
      const isOpen = dropdownContent.style.display === "block";

      // Close all other dropdowns
      dropdowns.forEach((d) => {
        const content = d.querySelector(".dropdown-content");
        if (content) content.style.display = "none";
      });

      // Toggle current dropdown
      dropdownContent.style.display = isOpen ? "none" : "block";
    });

    // Handle option click
    const options = dropdownContent.querySelectorAll("li");
    options.forEach((option) => {
      option.addEventListener("click", function (event) {
        event.stopPropagation();
        const selectedText = option.textContent;
        dropdownBtn.firstChild.textContent = selectedText;
        dropdownContent.style.display = "none";
      });
    });
  });

  // Close dropdowns on outside click
  window.addEventListener("click", function () {
    dropdowns.forEach((dropdown) => {
      const dropdownContent = dropdown.querySelector(".dropdown-content");
      if (dropdownContent) dropdownContent.style.display = "none";
    });
  });
}

initDropdownToggle();
$(window).on("load", function () {
  // Hide initial sections for both shades and curtains
  $(".shades-pattern, .shades-color, .curtain-pattern, .curtains-color").css(
    "display",
    "none"
  );
});

$(document).ready(function () {
  // Common function to initialize slick sliders
  function initializeSlick(selector) {
    $(selector).slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon.png?v=1746005857"></button>',
      nextArrow:
        '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon_1.png?v=1746005868"></button>',
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            arrows: true,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Function to handle tab switching and reinitializing sliders
  function handleTabSwitch(
    buttonSelector,
    showSelector,
    hideSelectors,
    slickSelector,
    timeout
  ) {
    $(buttonSelector).on("click", function () {
      // Show the relevant section
      $(showSelector).css("display", "block");
      // Hide the irrelevant sections
      hideSelectors.forEach((hideSelector) =>
        $(hideSelector).css("display", "none")
      );
      // Unslick and reinitialize the slider
      $(slickSelector).slick("unslick");
      setTimeout(function () {
        initializeSlick(slickSelector);
      }, timeout);
    });
  }

  // Shades tab handling
  handleTabSwitch(
    "#pat-sh",
    ".shades-pattern",
    [".shades-color", ".shades-sect"],
    ".multiple-items",
    80
  );
  handleTabSwitch(
    "#col-sh",
    ".shades-color",
    [".shades-pattern", ".shades-sect"],
    ".multiple-items",
    50
  );
  handleTabSwitch(
    "#fab-sh",
    ".shades-sect",
    [".shades-pattern", ".shades-color"],
    ".multiple-items",
    50
  );

  // Curtains tab handling
  handleTabSwitch(
    "#pat-cur",
    ".curtain-pattern",
    [".curtains-color", ".curtains-sect"],
    ".curtain-items",
    80
  );
  handleTabSwitch(
    "#col-cur",
    ".curtains-color",
    [".curtain-pattern", ".curtains-sect"],
    ".curtain-items",
    80
  );
  handleTabSwitch(
    "#fab-cur",
    ".curtains-sect",
    [".curtain-pattern", ".curtains-color"],
    ".curtain-items",
    80
  );

  // Initialize Slick for the first time
  initializeSlick(".multiple-items");
  initializeSlick(".curtain-items");

  // Product page slider
  setTimeout(function () {
    $(".p-slide")
      .slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon.png?v=1746005857"></button>',
        nextArrow:
          '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon_1.png?v=1746005868"></button>',
        responsive: [
          {
            breakpoint: 1450,
            settings: {
              arrows: true,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: true,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      })
      .slick("setPosition"); // Recalculate after initialization
  }, 50);

  // Handle "Read More" button toggle on collection banner
  $(".forcollection .collection_banner_readmore").click(function () {
    let btnTextSpan = $(this).find(".btn_text");
    let currentText = btnTextSpan.text();

    if (currentText == "Read More") {
      btnTextSpan.text("Read Less");
    } else {
      btnTextSpan.text("Read More");
    }

    $(this)
      .siblings(".collection_banner_description")
      .find(".coll_short_desc")
      .toggleClass("showfull");
  });

  // Recalculate slick position on window resize
  $(window).on("resize", function () {
    $(".p-slide").slick("setPosition");
  });
});

// $(document).ready(function () {
//   // Function to initialize slick slider
//   // function initializeSlick() {
//   //   if ($(window).width() < 749) {
//   //     $(".reviews-wrapper-content").not(".slick-initialized").slick({
//   //       infinite: true,
//   //       slidesToShow: 1,
//   //       slidesToScroll: 1,
//   //       prevArrow:
//   //         '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon.png?v=1746005857"></button>',
//   //       nextArrow:
//   //         '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon_1.png?v=1746005868"></button>',
//   //     });
//   //   }
//   // }

//   // // Initialize slick on document ready if width is below 749px
//   // initializeSlick();

//   // Reinitialize or destroy slider on window resize
//   $(window).on("resize", function () {
//     if ($(window).width() >= 749) {
//       if ($(".reviews-wrapper-content").hasClass("slick-initialized")) {
//         $(".reviews-wrapper-content").slick("unslick");
//       }
//     } else {
//       initializeSlick();
//     }
//   });
// });

$(document).ready(function () {
  // Function to initialize slick slider
  function initializeSlick() {
    if ($(window).width() < 749) {
      $(".blog-post-wrapper ").not(".slick-initialized").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon.png?v=1746005857"></button>',
        nextArrow:
          '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0718/8758/5539/files/icon_1.png?v=1746005868"></button>',
      });
    }
  }

  // Initialize slick on document ready if width is below 749px
  initializeSlick();

  // Reinitialize or destroy slider on window resize
  $(window).on("resize", function () {
    if ($(window).width() >= 991) {
      if ($(".blog-post-wrapper ").hasClass("slick-initialized")) {
        $(".blog-post-wrapper ").slick("unslick");
      }
    } else {
      initializeSlick();
    }
  });
});

// $("body").on("click", "li.list-menu__item.facets__item", function () {
//   const $target = $(this).parents(".parent-display.facets__display");
//   console.log($target);
//   $target.hide();
// });

// $("body").on(
//   "click",
//   "details.disclosure-has-popup.facets__disclosure.js-filter",
//   function () {
//     alert(333);
//     const $target = $(this).find(".parent-display.facets__display");
//     console.log($target);
//     $target.show();
//   }
// );
